const API_PREFIX = '/api/v1'
const ENVIORNMENT = 'development'
const ZERO = 0
const ONE = 1
const TWO = 2
const THREE = 3
const GET_REQUEST = 'get'
const POST_REQUEST = 'post'
const PATCH_REQUEST = 'patch'
const BOOLEAN_TRUE = true
const BOOLEAN_FALSE = false
const NULL = null
const EMPTY_STRING = ''
const REQUESTED_RECORD = 20
const CENTS = 100
const STATUS_403 = 403
const STATUS_200 = 200
const STATUS_401 = 401
const LOGOUT = '/logout'
const S3_BASE_URL = 'https://hireavendor.co.za'

// * api end point URL
const LOGIN_END_POINT = '/vendors/login'
const GET_SERVICE_END_POINT = '/get-services'
const GET_TAGS_END_POINT = '/get-tags'
const REGISTER_VENDOR_END_POINT = '/vendors/register'
const CHANGE_PASSWORD_END_POINT = '/vendors/update-password'
const VENDOR_DETAILS_END_POINT = '/vendors/vendor-details'
const QUOTATION_END_POINT = '/vendors/quotations'
const UPDATE_PROFILE_END_POINT = '/vendors/profile-update'
const DASHBOARD_END_POINT = '/vendors/dashboard'
const FORGOT_PASSWORD_END_POINT = '/vendors/vendor-forget-password'
const FORGOT_VERIFY_OTP_END_POINT = '/vendors/vendor-forget-verify-otp'
const RESET_PASSWORD_END_POINT = '/vendors/vendor-reset-password'
const UPDATE_BUSINES_DETAIL_END_POINT = '/vendors/update-business-profile'
const DELETE_VENDOR_IMAGE_END_POINT = '/vendors/vendor-business-image-delete'
const VIEW_VENDORS_END_POINT = '/vendors/business-details'
const DELETE_SERVICE_IMAGE_END_POINT = '/vendors/business-service-remove'

module.exports = {
    DELETE_SERVICE_IMAGE_END_POINT,
    VIEW_VENDORS_END_POINT,
    DELETE_VENDOR_IMAGE_END_POINT,
    UPDATE_BUSINES_DETAIL_END_POINT,
    RESET_PASSWORD_END_POINT,
    FORGOT_VERIFY_OTP_END_POINT,
    FORGOT_PASSWORD_END_POINT,
    DASHBOARD_END_POINT,
    UPDATE_PROFILE_END_POINT,
    QUOTATION_END_POINT,
    VENDOR_DETAILS_END_POINT,
    CHANGE_PASSWORD_END_POINT,
    REGISTER_VENDOR_END_POINT,
    GET_TAGS_END_POINT,
    LOGIN_END_POINT,
    GET_SERVICE_END_POINT,
    S3_BASE_URL,
    CENTS,
    LOGOUT,
    EMPTY_STRING,
    REQUESTED_RECORD,
    API_PREFIX,
    ENVIORNMENT,
    ZERO,
    THREE,
    ONE,
    STATUS_403,
    STATUS_401,
    STATUS_200,
    TWO,
    NULL,
    GET_REQUEST,
    POST_REQUEST,
    PATCH_REQUEST,
    BOOLEAN_TRUE,
    BOOLEAN_FALSE,
}